import { useState } from "react";
import { ArrowUpRight } from "lucide-react";
import { DESTINATIONS } from "../data/content";
import { FadeUp, SectionHead, Img } from "./Reveal";
import { useEnquiry } from "./EnquiryContext";

const FILTERS = ["All", "Wildlife", "Heritage", "Nature", "Spiritual", "City"];

export const Destinations = () => {
  const [filter, setFilter] = useState("All");
  const { openEnquiry } = useEnquiry();
  const list = filter === "All" ? DESTINATIONS : DESTINATIONS.filter((d) => d.cat === filter);

  return (
    <section id="destinations" data-testid="destinations-section" className="relative py-24 lg:py-36">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-10 mb-14">
          <SectionHead
            num="01"
            eyebrow="Explore Madhya Pradesh"
            title="Explore the Heart of India"
            copy="Twenty-three destinations across tiger reserves, temple towns, marble gorges and sacred rivers — the wild heart of the subcontinent."
          />
          <FadeUp delay={0.2} className="flex flex-wrap gap-2">
            {FILTERS.map((f) => (
              <button
                key={f}
                data-testid={`destination-filter-${f.toLowerCase()}`}
                onClick={() => setFilter(f)}
                className={`font-mono text-[11px] uppercase tracking-[0.18em] px-4 py-2 border transition-colors duration-300 ${
                  filter === f
                    ? "border-gold bg-gold text-forest-950"
                    : "border-cream/15 text-cream/60 hover:border-gold/50 hover:text-gold"
                }`}
              >
                {f}
              </button>
            ))}
          </FadeUp>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {list.map((d, i) => (
            <FadeUp
              key={d.name}
              delay={(i % 4) * 0.08}
              className={i % 9 === 0 ? "sm:col-span-2" : ""}
            >
              <button
                data-testid={`destination-card-${d.name.toLowerCase()}`}
                onClick={() => openEnquiry({ destination: d.name })}
                className="group relative block w-full text-left h-72 overflow-hidden"
              >
                <Img
                  src={d.img}
                  alt={d.name}
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-forest-950 via-forest-950/20 to-transparent" />
                <div className="absolute inset-0 border border-transparent group-hover:border-gold/50 transition-colors duration-500" />
                <div className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center border border-cream/20 text-cream/70 opacity-0 group-hover:opacity-100 group-hover:border-gold group-hover:text-gold transition-all duration-500">
                  <ArrowUpRight size={14} />
                </div>
                <div className="absolute bottom-0 inset-x-0 p-5">
                  <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-gold">
                    {d.cat}
                  </span>
                  <h3 className="font-serif text-2xl text-cream mt-1">{d.name}</h3>
                  <p className="text-sm text-cream/60 mt-1.5 leading-snug line-clamp-2 max-w-xs">
                    {d.desc}
                  </p>
                  <span className="inline-block mt-3 font-mono text-[10px] uppercase tracking-[0.25em] text-gold/80 group-hover:text-gold transition-colors">
                    Explore →
                  </span>
                </div>
              </button>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
};
